import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c178119c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "popup-main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-close-o"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "title-bar"
};
const _hoisted_5 = {
  class: "heighlight"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "hr"
}, null, -1));
const _hoisted_7 = {
  class: "heighlight"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rule"
}, [/*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, "1. 每日签到可领取5福米；"), /*#__PURE__*/_createElementVNode("li", null, "2. 每月累计签到7、14、21、28天分别额外获得20、50、100、200福米；"), /*#__PURE__*/_createElementVNode("li", null, "3. 累计签到福米按月更新。")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sign-popup-h5", {
      '--transformable': $setup.state.isTransformable,
      '--to-small': !$setup.state.isFullPage
    }])
  }, [_createElementVNode("div", {
    class: "popup-overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }), _createElementVNode("div", _hoisted_1, [$setup.state.isTransformable && !$setup.state.isFullPage ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "popup-toggle",
    href: "#",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $setup.toggleSize(), ["prevent"]))
  }, "签到日历")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "button-close",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_3)), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createTextVNode(_toDisplayString($setup.state.strThisMonth) + "月累计签到 ", 1), _createElementVNode("span", _hoisted_5, _toDisplayString($setup.state.checkedDayList.length), 1), _createTextVNode(" 天")]), _hoisted_6, _createElementVNode("span", null, [_createTextVNode("福米 "), _createElementVNode("span", _hoisted_7, _toDisplayString($setup.state.signTaskCredit), 1)])]), _createElementVNode("div", {
    class: _normalizeClass(["monthly-calendar", {
      'is-last-week': $setup.daysInMonth === $setup.daysInThisWeek.end
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysInMonth, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["monthly-calendar__day--box", {
        'is-this-week': item >= $setup.daysInThisWeek.start && item <= $setup.daysInThisWeek.end
      }]),
      key: 'day-' + item
    }, [_createElementVNode("div", {
      class: _normalizeClass(["monthly-calendar__day--border", {
        'checked': $setup.state.checkedDayList.indexOf(item) > -1,
        'today': item === $setup.state.strToday,
        'prize prize1': item === $setup.prizeDay1,
        'prize prize2': item === $setup.prizeDay2,
        'prize prize3': item === $setup.prizeDay3,
        'prize prize4': item === $setup.prizeDay4,
        'checked-prize': $setup.checkedPrize.indexOf(item) > -1
      }])
    }, _toDisplayString($setup.dayText(item)), 3)], 2);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fillUpDays, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "monthly-calendar__day--box empty",
      key: 'fill-' + item
    });
  }), 128))], 2), _hoisted_8])], 2);
}